<template>
    <h2>Notifications</h2>
</template>

<script>
export default {
    name: 'Notifications'
}
</script>